// extracted by mini-css-extract-plugin
export var modal = "_dc-0";